import { useMediaQuery } from '@src/app/css'
import type { ThemeKey } from '@ui/theme'
import type { StorageThemeKey } from '@ui/theme/isStorageThemeKey'

export default function usePreferredThemeKey(key: StorageThemeKey): ThemeKey {
  const preference = useMediaQuery('(prefers-color-scheme: dark)')

  switch (key) {
    case 'system':
      return preference ? 'dark' : 'light'
    case 'light':
      return 'light'
    case 'dark':
      return 'dark'
  }
}
